'use strict';

var Sugar = require('sugar-core');

require('./build/buildMathAliasesCall');

module.exports = Sugar.Number.asin;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/asin.js
// module id = 650
// module chunks = 0